$('#newsSns').find('a').on('click', function () {
  window.open(this.href, '_blank', 'width=600, height=600, menubar=no, toolbar=no, scrollbars=yes');
  return false;
});